import { ApiService } from './api';
import { ApiResponse } from '../types/auth';
import { SlotResponse, CreateSlotRequest, UpdateSlotRequest } from '../types/slots';
import { OrderAssignedDriverResponse } from '../types/orders';

class SlotsService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  async listSlots(page: number = 0, pageSize: number = 50): Promise<ApiResponse<SlotResponse[]>> {
    try {
      const data = await this.apiService.get<SlotResponse[]>(
        `/admin/slots?page=${page}&pageSize=${pageSize}`
      );
      return { success: true, data };
    } catch (error: any) {
      return { success: false, error: error.message || 'Failed to fetch slots' };
    }
  }

  async getSlot(slotId: number): Promise<ApiResponse<SlotResponse>> {
    try {
      const data = await this.apiService.get<SlotResponse>(`/admin/slots/${slotId}`);
      return { success: true, data };
    } catch (error: any) {
      return { success: false, error: error.message || 'Failed to fetch slot' };
    }
  }

  async createSlot(request: CreateSlotRequest): Promise<ApiResponse<SlotResponse>> {
    try {
      const data = await this.apiService.post<SlotResponse>('/admin/slots', request);
      return { success: true, data };
    } catch (error: any) {
      return { success: false, error: error.message || 'Failed to create slot' };
    }
  }

  async updateSlot(slotId: number, request: UpdateSlotRequest): Promise<ApiResponse<SlotResponse>> {
    try {
      const data = await this.apiService.put<SlotResponse>(`/admin/slots/${slotId}`, request);
      return { success: true, data };
    } catch (error: any) {
      return { success: false, error: error.message || 'Failed to update slot' };
    }
  }

  async deleteSlot(slotId: number): Promise<ApiResponse<void>> {
    try {
      await this.apiService.delete<void>(`/admin/slots/${slotId}`);
      return { success: true };
    } catch (error: any) {
      return { success: false, error: error.message || 'Failed to delete slot' };
    }
  }

  async getDriversForSlot(slotId: number): Promise<ApiResponse<OrderAssignedDriverResponse[]>> {
    try {
      const data = await this.apiService.get<OrderAssignedDriverResponse[]>(
        `/admin/slots/${slotId}/drivers`
      );
      return { success: true, data };
    } catch (error: any) {
      return { success: false, error: error.message || 'Failed to fetch slot drivers' };
    }
  }

  async addDriverToSlot(slotId: number, driverId: number): Promise<ApiResponse<void>> {
    try {
      await this.apiService.post<void>(`/admin/slots/${slotId}/drivers/${driverId}`, {});
      return { success: true };
    } catch (error: any) {
      return { success: false, error: error.message || 'Failed to add driver to slot' };
    }
  }

  async removeDriverFromSlot(slotId: number, driverId: number): Promise<ApiResponse<void>> {
    try {
      await this.apiService.delete<void>(`/admin/slots/${slotId}/drivers/${driverId}`);
      return { success: true };
    } catch (error: any) {
      return { success: false, error: error.message || 'Failed to remove driver from slot' };
    }
  }
}

export const slotsService = new SlotsService();
